const AUTH_API = process.env.REACT_APP_AUTH_API || "";

export function getToken() {
    return localStorage.getItem("rv_token") || "";
}
export function setToken(token) {
    localStorage.setItem("rv_token", token);
}
export function clearToken() {
    localStorage.removeItem("rv_token");
}

async function safeJson(res) {
    try { return await res.json(); } catch { return {}; }
}

export async function authFetch(path, options = {}) {
    const token = getToken();
    const headers = {
        "Content-Type": "application/json",
        ...(options.headers || {}),
    };
    if (token) headers.Authorization = `Bearer ${token}`;

    const res = await fetch(`${AUTH_API}${path}`, { ...options, headers });
    const data = await safeJson(res);

    if (!res.ok) {
        const msg = data?.detail || data?.message || `HTTP ${res.status}`;
        throw new Error(msg);
    }
    return data;
}

export async function login(email, password) {
    const r = await authFetch("/api/auth/login", {
        method: "POST",
        body: JSON.stringify({ email, password }),
    });
    setToken(r.access_token);
    return r;
}

export async function register(email, password) {
    const r = await authFetch("/api/auth/register", {
        method: "POST",
        body: JSON.stringify({ email, password }),
    });
    setToken(r.access_token);
    return r;
}

export async function me() {
    return authFetch("/api/auth/me");
}

export function logout() {
    clearToken();
}